const WORD_SPLIT = /\s+/

export function truncateToWords(
  text: string,
  maxWords = 30,
): { preview: string; isTruncated: boolean } {
  const trimmed = text.trim()
  if (!trimmed) {
    return { preview: '', isTruncated: false }
  }
  const words = trimmed.split(WORD_SPLIT).filter(Boolean)
  if (words.length <= maxWords) {
    return { preview: trimmed, isTruncated: false }
  }
  return {
    preview: words.slice(0, maxWords).join(' '),
    isTruncated: true,
  }
}
